import { TableV2 } from '@anytag/shared-atoms';
import { PostDetailsType } from '@anytag/shared-types';
import { TiktokSpecialCampaignReport } from '@anytag/graphql';
import { TikTokSpecialPostDetailsModal } from '@anytag/shared-molecules';
import { useTikTokCampaignReportContext } from '../TikTokCampaignReportContext';
import { useTikTokCampaignReportTable } from './hooks';
import { formatTikTokCampaignReportData } from './utils';

export interface TikTokCampaignReportTableProps {
  loading?: boolean;
  data: TiktokSpecialCampaignReport;
}

export const TikTokCampaignReportTable = ({ data, loading }: TikTokCampaignReportTableProps) => {
  const { segmentStatus } = useTikTokCampaignReportContext();
  const { columns } = useTikTokCampaignReportTable({ data });

  const tableData = formatTikTokCampaignReportData(data, segmentStatus);
  const allPosts = tableData.reduce<PostDetailsType[]>(
    (acc, { influencerInfo, postInfo }) => (influencerInfo && postInfo?.id ? [...acc, { id: postInfo.id }] : acc),
    []
  );

  return (
    <>
      <TableV2
        data={tableData}
        loading={loading}
        noTopBorderRadius
        maxHeight="820px"
        rowHeight="56px"
        columns={columns}
        className="report-table"
        stickyHeader
        hasColumnCustomization
      />

      <TikTokSpecialPostDetailsModal posts={allPosts} />
    </>
  );
};
